import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useStyle from './index.styles';
import { Outlet } from 'react-router-dom';
import Footer from '../../DLS/Footer';

const Dashboard = () => {
  const location = useLocation();
  const classes = useStyle();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  const getWrapClassName = () => {
    if (
      location.pathname.includes('/memorial/') ||
      location.pathname.includes('/memorials/new') ||
      location.pathname.includes('/add-comment/')
    ) {
      return 'bg-gradient1';
    }
    switch (location.pathname) {
      case '/home/account':
      case '/home/memorials/list':
      case '/home/memorials/comments-management':
      case '/home/price':
      case '/home/contact-us':
      case '/home/facebook-profile': {
        return 'bg-gradient1';
      }

      case '/home/start': {
        return '' /* classes.start */;
      }
      default:
        return '';
    }
  };

  const getContainerClassName = () => {
    switch (location.pathname) {
      case '/home/start': {
        return classes.start;
      }
      default:
        return 'max-w-[1024px] mx-auto';
    }
  };

  const hideFooterInMobile =
    location.pathname.includes('/memorials/new') ||
    location.pathname.includes('/memorial/') ||
    location.pathname.includes('/add-comment/') ||
    location.pathname === '/home/account' ||
    location.pathname === '/home/memorials/list' ||
    location.pathname === '/home/contact-us' ||
    location.pathname === '/home/facebook-profile' ||
    '/home/memorials/comments-management';

  return (
    <div
      className={`${getWrapClassName()} relative flex h-[calc(100vh-39px)] w-[100vw] max-w-[100vw] flex-col overflow-x-hidden md:h-[calc(100vh-80px)]`}
    >
      <div className="flex flex-1 flex-col overflow-y-auto" ref={containerRef}>
        <div className={`${getContainerClassName()} w-full flex-1`}>
          <Outlet />
        </div>
        <div className={`${hideFooterInMobile ? 'hidden md:block' : ''}`}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
